import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardActions, CardHeader, CardText } from 'material-ui/Card';
import PrivateIcon from 'material-ui/svg-icons/action/lock';

import PublicIcon from 'material-ui/svg-icons/action/lock-open';
import { statusColours } from '../../constants/ColourConstants';


let iconProps = {
    color: statusColours.default,
};

const AttendanceSegment = ({event, myAttendance = null, actions = [] }) => {
    const isPrivate = event.visibility === 'private';
    let subtitle;
    let notice = '';

    if (myAttendance.status) {
        switch (myAttendance.status) {
            case 'waiting':
                notice = 'You are on the waiting list';
                break;

            case 'attending':
                notice = 'You are attending this event';
                break;
        }
    }

    if (event.attendeeCount !== undefined) {
        const capacity = event.capacity; // may need to consider trainers
        if (event.displayRemaining) {
            const remaining = capacity - event.attendeeCount;
            subtitle = (remaining > 0) ? `${remaining} ${remaining > 1 ? 'places' : 'place'} available` : 'Fully booked';
        }
        if (event.displayCapacity && capacity > 0) {
            subtitle = `${!!subtitle ? `${subtitle}, ` : ''}${event.attendeeCount}/${capacity} attending`;
        }
    }
    if (!subtitle) {
        subtitle = isPrivate ? 'By invitation only' : 'Book your place at this event';
    }

    return  (
        <Card className="cent-card" key="enrolmentSegment">
            <CardHeader
                title="Attendance"
                subtitle={subtitle}
                avatar={isPrivate ? <PrivateIcon {...iconProps} /> : <PublicIcon {...iconProps} />}
            />
            {!!notice && (
                <CardText className="cent-card-text">
                    {notice}
                </CardText>
            )}
            {!!actions && (
                <CardActions className="cent-card-actions">
                    {actions}
                </CardActions>
            )}
        </Card>
    );
};

AttendanceSegment.propTypes = {
    event: PropTypes.object.isRequired,
};

export default AttendanceSegment;
